import { TableBody } from 'components/Table/TableBody/TableBody';
import { WorklistData, WorklistStatus } from 'models/worklist';
import { queryKeys, queryParams, WORKLIST_REFETCH_INTERVAL } from 'utils/query';
import { TableConfig } from 'models/general';
import { WorkListFilters } from 'components/Table/Filters/WorkListFilters';
import { useTableActions } from 'components/Table/Actions/WorkListActions';
import { WorkListColumns } from 'components/Table/Columns/WorkListColumns';
import { getWorkListRecords } from 'hooks/api/worklist/useGetWorklistRecords';
import { useSearchParameters } from 'hooks/useSearchParameters';
import { useAppContext } from 'context/hooks';
import { WrongAccountModal } from 'components/Modal/WrongAccountModal';
import { DataFieldNames, getWorkListRow } from './WorklistTable.config';

const workListConfig: TableConfig = {
  queryKey: queryKeys.worklistOverview,
  dataFieldNames: DataFieldNames,
  defaultFilters: {
    [queryParams.status]: WorklistStatus.Unread,
  },
  defaultSort: `-${DataFieldNames.priority}`,
  refetchInterval: WORKLIST_REFETCH_INTERVAL,
};

export const WorklistTable = () => {
  const { parameters: filters } = useSearchParameters(queryKeys.worklistOverview);
  const { currentUser } = useAppContext();

  const groupsFilter = filters[queryParams.groups];

  if (currentUser && groupsFilter) {
    const userGroupIds = new Set(currentUser.groups.map((g) => g.id));
    const invalidGroups = groupsFilter.split(',').filter((id) => !userGroupIds.has(id));
    if (invalidGroups.length > 0) {
      return <WrongAccountModal />;
    }
  }

  return (
    <TableBody<WorklistData>
      getData={getWorkListRecords}
      getColumns={WorkListColumns}
      getRow={getWorkListRow}
      config={workListConfig}
      filterBar={<WorkListFilters config={workListConfig} />}
      selectableRowId={(item) => item?.id}
      selectedFilter={(item) => item?.status === WorklistStatus.Unread}
      selectedActions={useTableActions}
    />
  );
};
